import { panel } from 'instantsearch.js/es/widgets';
import { isCollapsed, panelClasses, panelTemplates } from './common.js';

/**
 * Create a panel-wrapped widget with consistent styling
 * @param {Function} widgetCreator - The InstantSearch widget function
 * @param {Object} options - Panel and widget options
 * @returns {Object|null} Panel-wrapped widget instance
 */
export const createPanel = (widgetCreator, options) => {
  const { container, attribute, label, widgetOptions = {} } = options;

  if (!attribute) {
    console.error('Attribute is required for refinement widget');
    return null;
  }

  const containerEl =
    typeof container === 'string'
      ? document.querySelector(container)
      : container;

  if (!containerEl) {
    return null;
  }

  // Make entire header clickable for collapse/expand
  const setupHeaderClick = () => {
    const header = containerEl.querySelector('.ais-Panel-header');
    const button = containerEl.querySelector('.ais-Panel-collapseButton');
    if (header && button) {
      header.addEventListener('click', (e) => {
        // Don't double-trigger if clicking the button itself
        if (!e.target.closest('.ais-Panel-collapseButton')) {
          button.click();
        }
      });
    }
  };

  // Set up header click after a short delay to ensure DOM is ready
  setTimeout(setupHeaderClick, 0);

  return panel({
    templates: {
      header: () =>
        panelTemplates.header({ widgetParams: { label, attribute } }),
      collapseButtonText: panelTemplates.collapseButtonText,
    },
    collapsed: () => isCollapsed(containerEl),
    cssClasses: {
      root: panelClasses.root.join(' '),
      header: panelClasses.header.join(' '),
      body: panelClasses.body.join(' '),
      footer: panelClasses.footer.join(' '),
      collapsedRoot: panelClasses.collapsedRoot.join(' '),
      collapseButton: panelClasses.collapseButton.join(' '),
    },
  })(widgetCreator)({
    container: containerEl,
    attribute,
    ...widgetOptions,
    // Transform items to handle empty states
    transformItems: (items) => {
      const hasItems = items.length > 0;
      const classes = ['opacity-40', 's-empty', 'pointer-events-none'];

      if (!hasItems) {
        containerEl.classList.add(...classes);
      } else {
        containerEl.classList.remove(...classes);
      }

      return widgetOptions.transformItems
        ? widgetOptions.transformItems(items)
        : items;
    },
  });
};
